import { Middleware } from '@reduxjs/toolkit';

import {
  processPaymentSuccess,
  setActiveScreen,
  setPaymentResult,
} from '@cashier/cashier-data-access';
import {
  DynamicScreens,
  PaymentActionResult,
  ResultActionTypes,
} from '@cashier/cashier-model';

export const activeScreenMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === setPaymentResult.toString()) {
      store.dispatch(setActiveScreen(DynamicScreens.FinalScreen));
    }

    if (action.type === processPaymentSuccess.toString()) {
      const result: PaymentActionResult = action.payload;
      const { resultAction } = result;

      if (resultAction) {
        store.dispatch(
          setActiveScreen(
            ResultActionTypes.DISPLAY === resultAction.type
              ? DynamicScreens.FinalScreen
              : DynamicScreens.ProcessingResult,
          ),
        );
      }
    }

    return result;
  };
